import {Applications} from '../constants/ApiEndpoints';

export class PermissionLink {

  public static appendLink(module, action) {
    return Applications.APP + '.' + module + '.' + action;
  }
}
